// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"4a66eb75","245":"b497b332","285":"65933801","570":"6661e463","598":"29ec1c83","627":"95c33dad","947":"c3491810","993":"93d33abb"}[chunkId] + ".chunk.js";
};